export default "__VITE_ASSET__B2Ck1ibV__"